import React from 'react';
import Link from 'src/shared/components/Link';
import GaCategory from 'src/config/GaCategory';
import GaService from 'src/services/GaService';

import styles from './styles.module.scss';

export interface TabType {
    isFocused?: boolean;
    id: string;
    name: string;
    // TODO it should be url type
    href: any;
    onClick?: () => void;
}

interface TabBarProps {
    tabs: TabType[];
    focusedTab?: string;
}

const Tab = ({ isFocused, name, href, onClick }: TabType) => {
    return (
        <Link href={href} replace>
            <div className={`${styles.tab} ${isFocused ? styles.focused : ''}`} onClick={onClick} aria-hidden="true">
                <span>{name}</span>
            </div>
        </Link>
    );
};

const TabBar = ({ tabs, focusedTab }: TabBarProps) => {
    const focusedIndex = tabs.findIndex(({ id }) => id === focusedTab);

    const clickTab = (name) => {
        GaService.callEvent(GaCategory.marketing, 'Click Article Category Button', name);
    };

    return (
        <div className={styles.container}>
            {tabs.map((tab, idx) => (
                <Tab key={`tab-bar_tab-${tab.name}`} {...tab} isFocused={idx === focusedIndex} onClick={() => clickTab(tab.name)} />
            ))}
        </div>
    );
};

TabBar.defaultProps = {
    focusedTab: '',
};

export default TabBar;
